module.exports = __webpack_public_path__ + "img/authbg.990d692.png";